import type { ReportCourseBodyReason } from './reportCourseBodyReason';

export type ReportCourseBody = {
  /**
   * 상세 설명 (선택)
   * @maxLength 500
   */
  description?: string;
  /** 신고 사유 */
  reason: ReportCourseBodyReason;
};
